import { appColors, spacing } from '@backrs_ui/common-ui';

import { ResourceNugget } from '@backrs_ui/grow-ui/src/components/Lubav/nuggets/ResourceNugget';
import { LubavContact } from '@backrs_ui/grow-ui/src/models/models';

import { List, ListItem, Typography, Box, SxProps, Theme } from '@mui/material';

type ContactWithCommonalities = Readonly<
  LubavContact & {
    insights: readonly string[];
    questions: readonly string[];
    commonalities: string;
  }
>;

type CommonThreadsFormatterProps = Readonly<{
  contactWithCommonalities: ContactWithCommonalities;
}>;

export const CommonThreadsFormatter = ({
  contactWithCommonalities,
}: CommonThreadsFormatterProps) => {
  const { insights, questions, commonalities } = contactWithCommonalities;

  const contact: LubavContact = {
    id: contactWithCommonalities.id,
    relevance: contactWithCommonalities.relevance,
    metadata: { ...contactWithCommonalities.metadata },
  };

  return (
    <Box sx={userBoxStyle}>
      <ResourceNugget
        key={contact.id}
        type={contact.metadata.role === 'professional' ? 'backrs' : 'students'}
        resource={contact}
      />

      <Typography sx={commonalitiesStyle}>{commonalities}</Typography>

      {/* Insights */}
      <Typography sx={bulletTitleSxStyle}>{contact.metadata.name}'s insights:</Typography>
      {insights.length > 0 ? (
        <List sx={listStyle}>
          {insights.map((insight, index) => (
            <ListItem key={index} sx={listItemStyle}>
              {insight}
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>N/A</Typography>
      )}

      {/* Consider asking */}
      <Typography sx={bulletTitleSxStyle}>Consider asking:</Typography>
      {questions.length > 0 ? (
        <List sx={listStyle}>
          {questions.map((question, index) => (
            <ListItem key={index} sx={listItemStyle}>
              {question}
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>N/A</Typography>
      )}
    </Box>
  );
};

const userBoxStyle: SxProps<Theme> = {
  borderRadius: '18px',
  gap: spacing.spacing2,
  pl: spacing.spacing3,
  pr: spacing.spacing3,
};

const listStyle: SxProps<Theme> = {
  paddingLeft: spacing.spacing7,
  fontSize: '10.5pt',
};

const listItemStyle: SxProps<Theme> = {
  listStyleType: 'disc',
  display: 'list-item',
  pl: spacing.spacing1,
  pt: spacing.spacing1,
  pb: spacing.spacing1,
};

const bulletTitleSxStyle: SxProps<Theme> = {
  color: appColors.neutral.black,
  fontWeight: 'bold',
  mt: spacing.spacing2,
  ml: spacing.spacing3,
  fontSize: '11pt',
};

const commonalitiesStyle: SxProps<Theme> = {
  fontSize: '10.5pt',
  marginTop: spacing.spacing3,
};
